module.exports = __webpack_public_path__ + "static/media/confirmed.c70cb966.svg";